import PropTypes from 'prop-types'
import { Button, Table } from 'reactstrap'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import { DISCOUNT_FOR } from 'domains/voucher/constants/voucher-constants'
import VoucherService from 'domains/voucher/services/voucher-service'
import VoucherShipmentDiscountTableRow from './shipment-discount-table-row'
import VoucherItemDiscountTableRow from './item-discount-table-row.jsx'

const propTypes = {
  voucher: PropTypes.shape({
    id   : PropTypes.number.isRequired,
    code : PropTypes.string.isRequired,
    rule : PropTypes.object.isRequired
  }),
  handleClickApply: PropTypes.func
}

/**
 * Displays all details of a Voucher
 * @param {Object} voucher - voucher we want to show details
 */
const VoucherDetailView = ({ voucher, handleClickApply }) => {
  const isShipmentActive = VoucherService.isDiscountActive(voucher, DISCOUNT_FOR.SHIPMENT)
  const isItemActive     = VoucherService.isDiscountActive(voucher, DISCOUNT_FOR.ITEM)
  const rule             = voucher.rule

  const voucherImage = rule.image_url ? `${WEB_URL_CONSTANTS.HOMEPAGE}/${rule.image_url}` : 'https://via.placeholder.com/300x100'


  return (
    <>
      <img width='100%' src={ voucherImage } />
      <h4>{ rule.name }</h4>

      <Table>
        <tbody>
          <tr>
            <td>
              <i className="fas fa-clock" />
              { ' Berlaku Hingga' }
            </td>
            <td>{ rule.from_date } - { rule.to_date }</td>
          </tr>

          {
            isShipmentActive && (
              <VoucherShipmentDiscountTableRow voucher={ voucher } />
            )
          }

          {
            isItemActive && (
              <VoucherItemDiscountTableRow voucher = { voucher } />
            )
          }
        </tbody>
      </Table>

      <hr className='border-primary' />

      <div>
        <h4>Description:</h4>
        <p>{ rule.description }</p>
      </div>

      <div>
        <Button
          block
          color='primary'
          onClick={ () => handleClickApply(voucher) }
        >
          { 'Apply Voucher' }
        </Button>
      </div>
    </>
  )
}

VoucherDetailView.propTypes = propTypes

export default VoucherDetailView